import { Container, Typography, Box, Button } from '@mui/material';
import ReactYoutubePlayer from 'react-player/youtube';
import { useActiveStep } from '../hooks/useActiveStep';

export function TransactionDescription() {
  const {setActiveStep} = useActiveStep()
  return (
    <Container maxWidth="md">
      <Box sx={{ p: 2 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          データ取引とは
        </Typography>
        <Typography paragraph>もし動画が自動で再生されない場合、再生ボタンを押してください。</Typography>

        <Box
          sx={{
            position: 'relative',
            paddingTop: '56.25%', // 16:9 アスペクト比
            height: 0
          }}
        >
          <ReactYoutubePlayer
            url="https://youtu.be/l2i6kAk0svc"
            className="react-player"
            playing
            width="100%"
            height="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
            controls // コントロールを表示する場合
          />
        </Box>
        <Box display="flex" justifyContent="space-between" mt={2}>
          <Button variant="outlined" fullWidth onClick={() => setActiveStep("ConfirmationComprehensiveConsent")} sx={{ mt: 3, mb: 2, margin: 2 }}>
            戻る
          </Button>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            onClick={() => setActiveStep('TransactionAgreement')}
            sx={{ mt: 3, mb: 2, margin: 2 }}
          >
            次へ進む
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
